import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
const TypeAhead = (props) => {
    var _a;
    const id = React.useId();
    const [inputValue, setInputValue] = React.useState('');
    const [allOptions, setAllOptions] = React.useState([]);
    const [loading, setLoading] = React.useState(false);
    const [showDropdown, setShowDropdown] = React.useState(false);
    const containerRef = React.useRef(null);
    React.useEffect(() => {
        setLoading(true);
        props.options.then(data => {
            setAllOptions(data);
            setLoading(false);
        });
    }, [props.options]);
    React.useEffect(() => {
        if (props.value === undefined) {
            setInputValue('');
        }
        else if (props.canAddNew !== true) {
            setInputValue(props.inputLabel ? props.inputLabel(props.value) : String(props.optionLabel(props.value)));
        }
        else {
            if (props.value[0]) {
                setInputValue(props.inputLabel ? props.inputLabel(props.value[1]) : String(props.optionLabel(props.value[1])));
            }
            else {
                setInputValue(props.value[1]);
            }
        }
    }, [props.value]);
    React.useEffect(() => {
        function handleClickOutside(e) {
            if (containerRef.current && !containerRef.current.contains(e.target)) {
                setShowDropdown(false);
            }
        }
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);
    const filtered = props.filterOptions
        ? props.filterOptions(allOptions, inputValue)
        : allOptions.filter(x => {
            const label = props.inputLabel ? props.inputLabel(x) : String(props.optionLabel(x));
            return label.toLowerCase().includes(inputValue.toLowerCase());
        });
    const selectedValue = props.canAddNew && props.value && props.value[0] ? props.value[1] : props.value;
    return (_jsxs("div", { ref: containerRef, className: `form-floating position-relative ${props.className || ''}`, style: props.style, children: [_jsx("input", { id: id, type: "text", autoComplete: "off", autoCorrect: "off", autoCapitalize: "off", spellCheck: false, name: id, className: `form-control ${props.size === 'sm'
                    ? 'form-control-sm'
                    : props.size === 'lg'
                        ? 'form-control-lg'
                        : ''} ${props.invalid ? 'is-invalid' : ''}`, style: Object.assign({}, (props.renderSelectedValue && selectedValue && !showDropdown && { color: 'transparent' })), value: inputValue, onChange: e => {
                    setInputValue(e.target.value);
                    setShowDropdown(true);
                    if (props.allowFreeTyping) {
                        props.onFreeType(e.target.value);
                    }
                }, onFocus: () => setShowDropdown(true), placeholder: props.placeholder || props.label, disabled: props.disabled, required: props.required }), props.renderSelectedValue && selectedValue && !showDropdown && (_jsx("div", { className: "position-absolute d-flex align-items-center gap-2", style: {
                    top: '1.625rem',
                    left: '0.75rem',
                    pointerEvents: 'none',
                }, children: props.renderSelectedValue(selectedValue) })), _jsx("label", { htmlFor: id, children: props.label }), props.invalid && _jsx("div", { className: "invalid-feedback", children: props.invalid }), !showDropdown ? null : (_jsx("ul", { className: "list-group position-absolute w-100 z-3 mt-1", style: { maxHeight: 200, overflowY: 'auto' }, children: loading ? (_jsx("li", { className: "list-group-item text-muted text-center", children: (_a = props.loadingRender) !== null && _a !== void 0 ? _a : 'Loading...' })) : (_jsxs(_Fragment, { children: [filtered.map(option => (_jsx("li", { className: "list-group-item list-group-item-action", style: { cursor: 'pointer' }, onClick: () => {
                                var _a, _b;
                                setInputValue(props.inputLabel ? props.inputLabel(option) : String(props.optionLabel(option)));
                                setShowDropdown(false);
                                if (props.canAddNew)
                                    (_a = props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, [true, option]);
                                else
                                    (_b = props.onChange) === null || _b === void 0 ? void 0 : _b.call(props, option);
                            }, children: props.optionLabel(option) }, props.optionKey(option)))), props.canAddNew &&
                            inputValue &&
                            !allOptions.some(o => String(props.optionLabel(o)).toLowerCase() ===
                                inputValue.toLowerCase()) && (_jsx("li", { className: "list-group-item list-group-item-action text-primary", style: { cursor: 'pointer' }, onClick: () => {
                                var _a;
                                setShowDropdown(false);
                                (_a = props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, [false, inputValue]);
                            }, children: props.canAddNewText || `Add “${inputValue}”` }))] })) }))] }));
};
export default TypeAhead;
